module.exports = __webpack_public_path__ + "static/media/newfeed.3adc753f.svg";